<template>
  <Drawer
    :transfer="true"
    title="办理人设置"
    v-model="visible"
    placement="right"
    class="set_promoter"
    width="550px"
    :closable="false"
    :before-close="closeDrawer"
  >
    <div class="demo-drawer__content">
      <div class="drawer_content">
        <div>
          <!-- 当为人工审批时，展示下面的东西，复杂逻辑 -->
          <!-- 首先是一个tabs -->
          <Tabs name="approverTab" style="margintop: 10px">
            <TabPane
              label="设置办理人"
              name="approverSetting"
              tab="approverTab"
            >
              <dealwithInfo
                ref="dealwithInfoRef"
                v-if="visible"
                :dataConfig.sync="transactorConfig"
                typeTitle="办理人"
              />
            </TabPane>
            <TabPane
              label="表单操作权限"
              name="approverPermission"
              tab="approverTab"
            >
              <permissionInfo
                ref="permissionInfoRef"
                v-if="visible"
                :dataConfig="transactorConfig"
                :formOpAuthList="transactorConfig.formOpAuthList"
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
    <div class="demo-drawer__footer clear">
      <Button @click="closeDrawer">取 消</Button>
      <Button type="primary" @click="saveTransactor">确 定</Button>
    </div>
  </Drawer>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { permissionInfo, dealwithInfo } from '../drawerInfo';
import preload from '../../plugins/preload';
import { getAllUserByDepartment } from '@/api/workflow';
import { userTypeConfig } from './drawerConfig';
export default {
  components: { dealwithInfo, permissionInfo },
  props: ['directorMaxLevel'],
  data() {
    return {
      transactorConfig: {},
      visible: false
    };
  },
  computed: {
    ...mapState('workflow', ['transactorConfig1', 'transactorDrawer'])
  },
  watch: {
    transactorDrawer(value) {
      this.visible = value;
    },
    transactorConfig1(val) {
      this.transactorConfig = val.value;
    }
  },
  methods: {
    ...mapMutations('workflow', ['setTransactorConfig', 'setTransactor']),
    async saveTransactor() {
      const { userType, userNullProcType } = this.transactorConfig;
      // 如果选择的是部门的话，调用接口获取当前部门下的人数

      // 如果是指定人员｜指定部门｜指定角色时 保存对应选择的人员
      if (![4, 5].includes(userType)) {
        const { listName } = userTypeConfig[userType];
        const dealwithInfoDom = this.$refs.dealwithInfoRef;
        const { list } = dealwithInfoDom;
        const nodeUserList = list[listName];
        this.transactorConfig.nodeUserList = nodeUserList;
        if (userType == 1 && nodeUserList.length == 1) {
          this.transactorConfig.execType = 1;
        }
        this.transactorConfig.nodeExecUsers = nodeUserList.map(i => {
          // 当是部门的时候，后端要 relationId
          return userType == 2 ? i.relationId : i.id;
        });
      }
      if (
        this.transactorConfig.userType == 2 &&
        this.transactorConfig.nodeUserList.length > 0
      ) {
        const ids = this.transactorConfig.nodeUserList.map(i => i.id).join(',');
        const res = await getAllUserByDepartment(ids);
        const { code, data } = res.data;
        if (code == 200) {
          this.transactorConfig.departmentPersonNum = data.length;
        }
      }
      // 如果是指定人员时设置指定人员
      if (userType != 1 && userNullProcType == 3) {
        const dealwithInfoDom = this.$refs.dealwithInfoRef;
        const { userNullSelUserList = [] } = dealwithInfoDom;
        if (userNullSelUserList.length < 1) {
          this.$Message.error('指定人员不能为空');
          return;
        }
        this.transactorConfig.userNullSelUserList = userNullSelUserList;
        this.transactorConfig.userNullSelUserId = (
          userNullSelUserList[0] || {}
        ).id;
      } else {
        this.transactorConfig.userNullSelUserList = [];
        this.transactorConfig.userNullSelUserId = '';
      }
      const permissionInfoDom = this.$refs.permissionInfoRef;
      const formOpAuthList = permissionInfoDom.getFormOpAuthListData();
      this.transactorConfig.formOpAuthList = formOpAuthList;
      this.transactorConfig.error = !preload.setTransactorStr(
        this.transactorConfig
      );
      this.setTransactorConfig({
        value: this.transactorConfig,
        flag: true,
        id: this.transactorConfig1.id
      });
      this.$emit('update:nodeConfig', this.transactorConfig);
      this.closeDrawer();
    },
    closeDrawer() {
      this.setTransactor(false);
    }
  }
};
</script>
<style lang="less">
.set_promoter {
  .approver_content {
    padding-bottom: 10px;
    border-bottom: 1px solid #f2f2f2;
  }

  .approver_self_select .Button,
  .approver_content .Button {
    margin-bottom: 20px;
  }

  .approver_content .Radio,
  .approver_some .Radio,
  .approver_self_select .Radio {
    width: 27%;
    margin-bottom: 20px;
  }

  .approver_manager p {
    line-height: 32px;
  }

  .approver_manager select {
    width: 420px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(217, 217, 217, 1);
  }

  .approver_manager p.tip {
    margin: 10px 0 22px 0;
    font-size: 12px;
    line-height: 16px;
    color: #f8642d;
  }

  .approver_self {
    padding: 28px 20px;
  }

  .approver_self_select,
  .approver_manager,
  .approver_content,
  .approver_some {
    padding: 20px 20px 0;
  }

  .approver_manager p:first-of-type,
  .approver_some p {
    line-height: 19px;
    font-size: 14px;
    margin-bottom: 14px;
  }

  .approver_self_select h3 {
    margin: 5px 0 20px;
    font-size: 14px;
    font-weight: bold;
    line-height: 19px;
  }
}
</style>
